export default "__VITE_ASSET__a886ec14__"